import React, {Fragment, useState, useEffect} from 'react';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { Card, CardContent } from '@mui/material';
import { TablaPersonalizada } from 'components';
import TituloConIcono from 'components/tituloConIcono';
import { obtenerRegistrosPersonalizadoPublic } from 'store/actions/customAction';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { useDispatch } from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';

const MostrarInformacion= ({title, openFullScreenDialog, handleClose, informacionObtenida, datosDelFormularioFiltrado}) => {
  const dispatch = useDispatch();
  const [listadoDeRegistrosDeMedios, setListadoDeRegistrosDeMedios] = useState([]);
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const [ordenesDeTransmision] = useState("ordenesDeTransmision");
  const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });

  useEffect(() => { buscarFiltro() }, []);

  const buscarFiltro = async () => {
    const {  nivelDeCobertura, tipoDeCandidatura, fechaDeOrdenes} = datosDelFormularioFiltrado;

    setcargandoSolicitud(true);
    ServiciosDelAPI[ordenesDeTransmision].setearMetodoPublico(true);
    ServiciosDelAPI[ordenesDeTransmision].metodoDeBusqueda.clear();
    ServiciosDelAPI[ordenesDeTransmision].metodoDeOrden.clear();
    ServiciosDelAPI[ordenesDeTransmision].metodoDeOrden.addAsc("idEspacio");

    let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
        controller: ordenesDeTransmision,
        saveInStore: false,
        nombreDelMetodo: `listar/espaciosAsignados/${fechaDeOrdenes?.id}/${informacionObtenida?.idMedio}/${tipoDeCandidatura?.id}/${nivelDeCobertura?.id || ""}` ,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || 'No se pudó obtener los datos', true, );
    
    if(respuesta?.data?.length === 0) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este filtro', true, );

    if(!respuesta?.data) return changeDataResponse('error', respuesta?.error?.message || 'No existen datos para este filtro', true, );

    setListadoDeRegistrosDeMedios(respuesta?.data || [])
}

  const [header] = useState([
    { title: 'Descripción', field: 'descripcionDeFactura'},
    { title: 'Fecha', field: 'fechaDeAsignacion'},
    { title: 'Cantidad', field: 'cantidadDeEspaciosAsignados'},
    { title: 'Costo Unitario (Iva Incluido)', field: 'precioUnidad'},
    { title: 'Total', field: 'subtotal'},
  ]);

  const handClose = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,})

  const cerrarPantallaCompleta = function() {
    handleClose();
  }

  const { errorType, messageType, openResponse} = responseData;

  return (
    <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={cerrarPantallaCompleta}
        title={title}
        fullscreen={true}
    >
      <Fragment>
          {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
          <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
          <Card>
              <CardContent>
              <TituloConIcono title={`Listado de Spot a transmitir del ${informacionObtenida?.rangoInicial || ""} AL ${informacionObtenida?.rangoFinal || ""}`} icon={""} mostrarBotones={false} mostrarTiempo={false} />

                  <TablaPersonalizada
                    data={listadoDeRegistrosDeMedios}
                    title={""}
                    header={header}
                    refreshList={undefined}
                    addRegister={undefined}
                    nameToolTipAdd={""}
                  />
              </CardContent>
          </Card>
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

export default MostrarInformacion;